import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../../common/components/form/form.module'


export default function DeliveryDateBasicInfoComponent ({handleInnerFormChange, selectedDeliveryDates}: any) {
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
         
          <InputContainer

                  label="Name"
                  name="Name"
                  onValueChange={(event: any) => {
                    handleInnerFormChange(
                      event.target.value,
                       'Name',

                         )
                       }}
                   type="text"
                   value={selectedDeliveryDates?.Name}
                />
            <InputContainer
              label="DisplayOrder"
              name="DisplayOrder"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DisplayOrder',

                )
              }}
              type="number"
              value={selectedDeliveryDates?.DisplayOrder}
          />
     </div>
  }
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}